import { componentName, PasscodeClass } from './PasscodeClass';
import '../descope-text-field';
import '../descope-loader-radial';
import './descope-passcode-internal';

customElements.define(componentName, PasscodeClass);

export { PasscodeClass, componentName };
